// swiper.js & css
import {calcTop} from '@utils/index.js'

// 数据埋码
function GAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
        "event":"ga4Event",
        "event_name":"anniversary_page_user_clicks",
        "event_parameters":{
            "current_page": window.location.href, // current page url,
            "module": "directory",
            ...params
        }
    })
}

export function InitCollectionTabs() {
    if(document.querySelector(".collection-wrapper-container")) return
    let scrolling = false
    const tabSwiper = new Swiper(".collection-tabs-content", {
      slidesPerView: 'auto'
    });

    const allHeights = (function() {
        const allHeight = []
        let uls = $(".collection-hero .collection-title");
        Array.from(uls).forEach((v) => {
            const key = $(v).attr("data-anchor")
            allHeight.push({
                collection: [key],
                value: v.getBoundingClientRect().top + window.pageYOffset - 40
            })
        });
        return allHeight
    })()

    $(".collection-tabs .scroll-wrapper .collection-tab-item").click(function(e) {
        tabSwiper.slideTo($(this).index(), 300, false);
        const _this = $(this)

        const target_name = $(this).attr('data-anchor')
        let t_ = ".collection-hero .collection-title[data-anchor='"+ target_name +"']"

        scrolling = true
        $('html, body').animate({
            scrollTop: $(t_).offset().top - $(".collection-tabs").height() - 40
        }, 300, 'swing', function() {
            scrolling = false
            $(".collection-tabs .scroll-wrapper .collection-tab-item").removeClass("active")
            _this.addClass("active")
        });

        // 数据埋码
        GAEvent({
            position: $(this).attr('data-title'),
            status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
        })
    })

    window.addEventListener("scroll", throttle(() => {
        if(scrolling) return
        const yScroll = window.pageYOffset || document.documentElement.scrollTop;
        const viewCollection = allHeights.find((item, index) => {
            if(index === allHeights.length - 1) {
                return yScroll >= item.value - $(".collection-tabs").height()
            }
            return yScroll >= item.value - $(".collection-tabs").height() && yScroll <= allHeights[index + 1]["value"] - $(".collection-tabs").height() - 40
        })
        if(viewCollection) {
            tabSwiper.slideTo($(`.collection-tabs .scroll-wrapper .collection-tab-item[data-anchor=${viewCollection.collection}]`).index(), 300, false);
            $(".collection-tabs .scroll-wrapper .collection-tab-item").removeClass("active")
            $(`.collection-tabs .scroll-wrapper .collection-tab-item[data-anchor=${viewCollection.collection}]`).addClass("active")
        }
    }, 80))
}